import React, {useState, useEffect} from 'react';
import {ReactComponent as DetailIcon } from '../../assets/icons/Detail.svg'
import { Table, Button } from '@mantine/core';
import {getFormattedDateTime} from '../../utils/getFormattedDateTime'
import TableMedusa from '../../components/Table';
import { OperationsListProps } from '../../types/operations';
import { useNavigate } from 'react-router-dom';
import { CreateOperationsMaps } from './OperationsMaps';

const OperationsList = ({data, showPast}:OperationsListProps)=>{
    const [rows, setRows] = useState<React.ReactElement[]>([]);

    const icon = <DetailIcon width={19} height={19}></DetailIcon>;
    const navigate = useNavigate();

    const onClickDetail = (operationId:number, recipeId:number)=>{
      navigate(`/operations/${operationId}?recipeId=${recipeId}`);
    }

    useEffect(() => {
        const fetchMaps = async () => {
            try {
                const { sorterMap, beltMap, recipeMap, statusMap } = await CreateOperationsMaps();

                const filteredData = showPast
                    ? data
                    : (data || []).filter(d => d.status_id === 1 || d.status_id === 2);

                const rows = filteredData?.map(({operation_id, sorter_id, belt_id, recipe_id, effective_from, status_id}) => (
                        <Table.Tr key={operation_id}>
                            <Table.Td>{getFormattedDateTime(new Date(effective_from))}</Table.Td>
                            <Table.Td>{sorterMap.get(sorter_id)}</Table.Td>
                            <Table.Td>{beltMap.get(belt_id)}</Table.Td>
                            <Table.Td>{recipeMap.get(recipe_id)}</Table.Td>
                            <Table.Td>{statusMap.get(status_id)} </Table.Td>
                            <Table.Td>
                                <Button variant="transparent" onClick={()=>onClickDetail(operation_id, recipe_id)}>{icon}</Button>
                            </Table.Td>
                        
                            </Table.Tr>

                ));
                setRows(rows || []);

            } catch (error) {
                console.error('Error loading maps:', error);
            }
            };

            fetchMaps();
    }, [data, showPast]);



    return(
        <div>
           <TableMedusa headers={["Start Time", "Sorter", "Belt", "Recipe", "Status"]} rows={rows}></TableMedusa>
        </div>
    );
}


export default OperationsList